import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { Box } from "rizzui/box";
import { Button } from "rizzui/button";
import { Text, Title } from "rizzui/typography";
import { useModal } from "../../hooks/useModal";
import ImportMultipleFiles from "../../component/cards/importMultipleFile";

export default function BlankPage() {
  const textStyle =
    "font-switzer font-[400] text-[14px] text-[#758599] leading-[18.48px]";
  const spanStyle = "font-[500] text-primary-dark underline";
  const { openModal } = useModal();

  return (
    <div className="h-full flex flex-row justify-center xl:justify-start xl:pl-[345px] items-center">
      <div className="flex flex-col gap-[38px]">
        <div className="w-[275px] flex flex-col gap-[24px]">
          <Text className="font-ibmPlexSerif text-primary-dark font-[600] text-[18px] leading-[23.4px]">
            Knowledge base
          </Text>
          <Text className="font-gilroy text-secondary-dark font-[400] text-[14px] leading-[16.8px]">
            A knowledge base is a collection of resources that your AI assistant
            can easily access for information.
            <Text className="mt-[20px]">
              You can upload a PDF, etc and attach it to your assistants, they
              pull from these for more context during conversations.
            </Text>
          </Text>
        </div>

        <Button
          variant="text"
          className="bg-btn hover:bg-btn text-foreground hover:text-foreground"
          onClick={() =>
            openModal({
              view: (
                <ImportMultipleFiles
                  page="knowledgebase"
                  setUploaded={() => console.log()}
                />
              ),
            })
          }
        >
          Import file{"("}s{")"}
        </Button>
      </div>
    </div>
  );
}
